import uniqBy from 'lodash/uniqBy';

import { FundState } from '@/pages/Order/steps/OrderDetails/types/FundState';

export const hasFundsMultipleCurrencies = (funds: FundState[]): boolean => {
  const fundsWithValue = funds.filter((fund) => fund.value > 0);
  return uniqBy(fundsWithValue, (fund) => fund.currency).length > 1;
};
